import { client } from '@@api/client';
import { CONTENT_LANGUAGE_HEADER } from '@@api/constants/headers';
import { type ContentLanguage } from '@@lib/i18n/constants';

export const sitemapTreeQuery = (
    tenantId: number,
    q: string | undefined,
    contentLocale: ContentLanguage,
) =>
    client.tenant.sitemaps.getAll.queryOptions({
        params: { id: tenantId },
        query: { q },
        headers: { [CONTENT_LANGUAGE_HEADER]: contentLocale },
    });
